const CAR = {
  length: 4.62,
  width: 1.84,
  wheelbase: 2.76,
  /** Wheel-centre to wheel-centre. */
  track: 1.58,
  /** Tyre outer radius — a 225/55 R17 measures 0.339 m. */
  wheelRadius: 0.34,
  tyreWidth: 0.225,
  /** Bottom of the visible bodywork between the wheels. */
  sillY: 0.3,
  /** Top of the lower body shell, where the glasshouse starts. */
  beltlineY: 0.95,
  /** Gap between tyre and wheel arch. Tight, so the tyre fills the arch. */
  archClearance: 0.055,
  /** Glasshouse inset per side, which gives the body its tumblehome. */
  glasshouseInset: 0.11
};
const NOSE_X = CAR.length / 2;
const TAIL_X = -CAR.length / 2;
const FRONT_AXLE_X = CAR.wheelbase / 2;
const REAR_AXLE_X = -CAR.wheelbase / 2;
const ARCH_RADIUS = CAR.wheelRadius + CAR.archClearance;
const HALF_TRACK = CAR.track / 2;
export {
  ARCH_RADIUS,
  CAR,
  FRONT_AXLE_X,
  HALF_TRACK,
  NOSE_X,
  REAR_AXLE_X,
  TAIL_X
};
